/**
 *  Downloading State
 *
 *  Displays the downloading and waiting for the detection app info.
 */

import React, { useEffect, useState } from "react";
import { Typography, Row, Col, Alert } from "antd";
import { Arrow } from "./Arrow";

const { Title } = Typography;
const warningTimeout = 5000;

export const Downloading = () => {
  const [warning, setWarning] = useState(false);

  useEffect(() => {
    let id = setTimeout(() => {
      setWarning(true);
    }, warningTimeout);

    return () => {
      clearTimeout(id);
    };
  }, []);

  // Render.
  return (
    <>
      <Title level={4}>Please run the Detection Application to finish analyzing your computer.</Title>
      <Row type='flex' justify='center'>
        <Col span={16}>
          {warning ? (
            <Alert
              message='Waiting for Application'
              description='The application must be run to continue the detection process.'
              type='warning'
              showIcon='true'
            />
          ) : null}
          <Title className='text-start mt-3' level={5}>
            The Detection app is:
          </Title>
          <ul className='text-start'>
            <li>Entirely safe to run.</li>
            <li>Easy to uninstall by just deleting the app.</li>
          </ul>
        </Col>
      </Row>
      <Arrow />
    </>
  );
};
